import React, { Fragment } from "react";
import { Container, Row, Col, Carousel} from "react-bootstrap";
import { Link } from "react-router-dom";


const HackingCreativity = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" style={{backgroundImage: 'url(/images/hackingCreativity/corpInnovation.jpg)', backgroundSize: 'cover'}}>
        <h1 className="display-3" style={{color:'white'}}>Innovation <em>First</em> Strategy</h1>
        <h4 style={{color:'white', fontStyle:'italic'}}>Building Innovative Company Cultures</h4>
      </div> 

      <Container className="m-5 p-5 border rounded border-primary">
         <Row className="mt-5 mb-3">
            <Col className="col-12 col-md-4 text-center">
               <h1 className="display-2" style={{color:'#153574'}}> 3X </h1>
               <p style={{fontStyle:'italic'}}> (more profitability for firms that build innovation-friendly processes)</p>
            </Col>

            <Col className="col-12 col-md-8 text-left">
               <p> <span style={{color: '#153574', fontWeight:'bold'}}> Innovation First</span> strategy places innovation at the heart of organizational endeavor. It’s a first principles approach to organizational development and starts with the true purpose of any modern organization - <em> to innovate. </em> </p>
               <p className = "lead" style={{color:'#ae7810'}}> In a creative economy, building an innovation-focused, human-centered culture is the <em>only</em> sustainable competitive advantage.</p>
       
            </Col>
         </Row>

         <Row className="mx-3 mb-3">
            <Col className="col-12 col-md-4 text-center">
               <img className="img-fluid"
                     src="/images/hackingCreativity/IF-Profit.png"
                     height="50%"
                     width = "50%"
                     alt="Profit"
               />
               <h5 style={{color:'#ae7810'}}>Profit</h5>
               <p>
                  Companies that embrace an innovation-focused culture are more profitable.
               </p>
            </Col>

            <Col className="col-12 col-md-4 text-center">
               <img className="img-fluid"
                     src="/images/hackingCreativity/IF-DEI.png"
                     height="50%"
                     width = "50%"
                     alt="Profit"
               />
               <h5 style={{color:'#ae7810'}}>Diversity and Inclusion</h5>
               <p>
                  Group norms that improve creativity also improve inclusion and equity for minority groups.
               </p>
            </Col>

            <Col className="col-12 col-md-4 text-center">
               <img className="img-fluid"
                     src="/images/hackingCreativity/IF-Engagement.png"
                     height="50%"
                     width = "50%"
                     alt="Profit"
               />
               <h5 style={{color:'#ae7810'}}>Employee Engagement</h5>
               <p>
                  Organizations that value employee driven innovation have higher employee engagement.
               </p>
            </Col>
         </Row>

         <Row className="mx-3 mb-3">
            <p className="lead"> (Download our <Link to="/docs/hackingCreativity/1nnovationFirstWhitePaper.pdf" target="_blank">white paper </Link> to learn how <span style={{color: '#153574'}}>Innovation First </span> can transform your culture.)</p>
         </Row>

      </Container>

      <Container>
         <Row className="mb-1">
            <Col className="col-12">
               <h3 className="display-4">Our Corporate Programs</h3>
            </Col>
         </Row>
         <Row className="mb-2">
            <p style={{fontStyle:'italic'}}>We help your business become more competitive in this new innovation-driven economy. We work at every level - organization, team and individual.</p>
            <p className="lead" style={{color: '#ae7810'}}>
               Organizations gain effective, practical tools to build a more innovative and motivating culture.
            </p>
            <p>
               <span> With over 10,000 hours in cognitive creativity, emotional intelligence and executive leadership, we have designed our programs to be insightful and effective. We work closely with you to identify your organizational needs and create customizable programs that are unique for your organization. </span>
            </p>

            <p>
               Interested in learning more? Please send an email to <span style={{color:'#ae7810'}}> <strong> hello@mindantix.com</strong></span>.
            </p>
         </Row>

         <Row className="mb-5 py-5" style={{backgroundColor:'#153574'}}>
            <Col className="col-12 col-md-4">
               <img className="img-fluid"
                     src="/images/hackingCreativity/HC-MetricsIcon.png"
                     height="50%"
                     width = "50%"
                     alt="Metrics"
               />
               <h4 style={{color:'#ae7810'}}>Innovation Assessment</h4>
               <p style={{color:'#bbbbbb'}}>
                Our Innovation Readiness assessment helps you identify areas that are blocking you from successfuly tapping employee innovation.
               </p>
            </Col>

            <Col className="col-12 col-md-4">
               <img className="img-fluid"
                     src="/images/hackingCreativity/HC-IndivIcon.png"
                     height="50%"
                     width = "50%"
                     alt="Profit"
               />
               <h4 style={{color:'#ae7810'}}>Creativity Trainings</h4>
               <p style={{color:'#bbbbbb'}}>
               Learn the foundations of cognitive creativity, emotional intelligence and teaming for a more creative life for yourself and your team.
               </p>
            </Col>

            <Col className="col-12 col-md-4">
               <img className="img-fluid"
                     src="/images/hackingCreativity/HC-OrgIcon.png"
                     height="50%"
                     width = "50%"
                     alt="Profit"
               />
               <h4 style={{color:'#ae7810'}}>Culture Co-creation</h4>
               <p style={{color:'#bbbbbb'}}>
               We work with you to identify creativity bottlenecks in your organization and co-design culture transforming solutions.
               </p>
            </Col>

         </Row>
      </Container>

      <Container>
         <Row>
            <h3 className="display-4 text-center mt-3"> <span style={{color:'#153574'}}> What Our Users Are Saying</span></h3>
         </Row>
         <Row className="mb-5">
            <Col className="col-md-1">
               <h1 className="display-1 text-right"> <span className="mb-0 pb-0" style={{fontFamily: 'Times New Roman', color:'#ae7810'}}> &ldquo;</span></h1>
            </Col>
            <Col className="col-md-11">
            <Carousel> 
               <Carousel.Item interval={1500}> 
               <img 
                  className="d-block w-100"
                  src="images/hackingCreativity/CarouselBackground.png"
                  alt="Carousel Background"
               /> 
               <Carousel.Caption> 
                  <p className="text-white lead">The workshop was so fun and enlightening! It was great to see how simple changes (like using the "yes, and" framework) can do so much to boost creativity within teams. I'll be implementing learnings from the session right away.</p> 
                  <p className="small"> <strong> - Nick Ellingson,</strong> Startup Ambassador and Director of Products at WTIA</p> 
               </Carousel.Caption> 
            </Carousel.Item> 

            
            <Carousel.Item interval={1500}> 
               <img 
                  className="d-block w-100"
                  src="images/hackingCreativity/CarouselBackground.png"
                  alt="Carousel Background"
               /> 
               <Carousel.Caption> 
                  <p className="text-white lead">I didn't want it to end; more time more fun!</p> 
                  <p><strong> - Engineering Manager</strong> at Amazon </p> 
               </Carousel.Caption> 
            </Carousel.Item> 

            <Carousel.Item interval={1500}> 
               <img 
                  className="d-block w-100"
                  src="images/hackingCreativity/CarouselBackground.png"
                  alt="Carousel Background"
               /> 
               <Carousel.Caption> 
                  <p className="text-white lead">Hacking Creativity 101 is a fun and engaging way for teams to learn how they can become more creative and collaborative.</p> 
                  <p><strong> - Mark Kotzer,</strong> Corporate Innovation Evangelist </p> 
               </Carousel.Caption> 
            </Carousel.Item> 


            </Carousel> 

            </Col>

         </Row>
      </Container>

      
      

    </Fragment>
       
  );
};
  
export default HackingCreativity;